import {
  ExclamationCircleOutlined,
  LogoutOutlined
} from "@ant-design/icons";
import { makeStyles } from "@mui/styles";
import { Avatar, Button, Descriptions, Dropdown, Menu, Modal, Layout as SideBar, Tag } from "antd";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AppIcon from "../../assets/images/AppIcon.png";
import AppLogo from "../../assets/images/prefectosblack.png";
import { useRealTimeTacho } from "../../hook/useRealTimeTacho";
import useSound from "use-sound";
import { Howler } from "howler";
import alertSound from "../../assets/sounds/alert.mp3";
import AuthService from "../auth/AuthService";
import useWindowWidth from "../common/CommonFun";
import Loading from "../loading/Loading";
import "./layout.css";
import BreakAlertModal from "./BreakAlertModal";


const useStyles = makeStyles((theme) => ({

  dataSheet: {
    "& .ant-descriptions.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-row >.ant-descriptions-item-content": {
      padding: "0px 2px !important"
    },
    "& .ant-descriptions.ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-row >.ant-descriptions-item-label": {
      padding: "4px 8px !important"

    }
  },
}));
const Auth = new AuthService();

const { Header, Content, Sider } = SideBar;

const AppLayout = () => {
  const { activeTab } = useSelector((state) => state.UIState);
  const { contentLoading } = useSelector((state) => state.AppState?.driverData);
  const { reportSubmit } = useSelector((state) => state?.AppState?.driverData);
  const [ReportSubmitData, setReportSubmitData] = useState(reportSubmit);
  const [currTab, setCurrTab] = useState(activeTab);
  const [showReport, setShowReport] = useState(false);
  const [tick, setTick] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [violationAcknowledged, setViolationAcknowledged] = useState(false);
  const [manualTachos, setManualTachos] = useState(
    () => localStorage.getItem("manualTachos")
  );
  const { violation, formattedTime } = useRealTimeTacho(manualTachos, tick);
  const [play, { stop }] = useSound(alertSound, {
    loop: true,
    html5: true,
    interrupt: true
  });


  useEffect(() => {
    const item = reportSubmit?.find(item => item.route_id === selectedRoute);
    if (item && item.status === true) {
      setShowReport(true)
    }
    if (item && item.status === false) {
      setShowReport(false)
    }
  }, [currTab])

  const { selectedRoute } = useSelector(
    (state) => state.AppState?.driverData
  );
  const { driverRoutes } = useSelector(
    (state) => state.AppState?.driverData
  );
  const selectedRouteData = driverRoutes.find((route) => route.id === selectedRoute);

  const currentRoute = driverRoutes.find((item => item.id === selectedRoute))
  const currWidth = useWindowWidth();
  const classes = useStyles();


  // const [collapsed, setCollapsed] = useState(currWidth <= 780);
  const [collapsed, setCollapsed] = useState(true);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const name = localStorage.getItem("DriverName");
  const routeName = localStorage.getItem("route_name");
  const securityPinExists = localStorage.getItem("securityPin");
  const deliveryDate = localStorage.getItem("delivery_date");

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.removeItem("manualTachos");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
    setShowReport(false)

  };

  useMemo(() => {
    dispatch({ type: "SET_ACTIVE_TAB", payload: location.pathname });
    setCurrTab(activeTab);
  }, [location, dispatch, activeTab]);

  useMemo(() => {
    let validity;
    const pinExpiration = localStorage.getItem("pinExpiration");
    if (pinExpiration && moment(pinExpiration) < moment()) {
      validity = false;
    } else {
      validity = true;
    }
    dispatch({ type: "SET_PIN_VALIDITY", payload: validity });
  }, [location, dispatch]);

  const menu = (
    <Menu>
      <Menu.Item
        key="sign-out"
        onClick={handleLogout}
        icon={<LogoutOutlined />}
      >
        Sign Out
      </Menu.Item>
    </Menu>
  );

  const reportAccident = () => {
    const data = {
      route_id: selectedRouteData?.route_id,
      vehicle_id: selectedRouteData?.vehicle_id,
      driver_id: selectedRouteData?.driver_id
    }
    navigate("/accident", { state: { accidentReportData: data } });
  }

  const [previousCoords, setPreviousCoords] = useState({ latitude: null, longitude: null });

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    if (lat1 === null || lon1 === null || lat2 === null || lon2 === null) {
      return Infinity;
    }

    const toRadians = (degrees) => (degrees * Math.PI) / 180;
    const R = 6371e3;

    const φ1 = toRadians(lat1);
    const φ2 = toRadians(lat2);
    const Δφ = toRadians(lat2 - lat1);
    const Δλ = toRadians(lon2 - lon1);

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  };

  const sendCoordinates = async (latitude, longitude) => {
    const dataToSend = {
      route_status_id: selectedRouteData?.id,
      latitude: latitude,
      longitude: longitude,
    };
    const distance = calculateDistance(
      previousCoords.latitude,
      previousCoords.longitude,
      latitude,
      longitude
    );
    if (distance > 100) {
      try {
        const response = await Auth.fetch(`/driverapp/driver-live-location`, {
          method: "POST",
          body: JSON.stringify(dataToSend),
        });
        if (response?.ack) {
          console.log(response);
          setPreviousCoords({ latitude, longitude });
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log("Distance is less than 100 meters.");
    }

  };

  const handleLocationUpdate = (position) => {

    const { latitude, longitude } = position.coords;
    const newDate = new Date();
    const new1 = moment(newDate).format('YYYY-MM-DD');
    if (deliveryDate == new1) {
      console.log('checking date');
      sendCoordinates(latitude, longitude);
    }

    // if (previousCoords.latitude !== latitude || previousCoords.longitude !== longitude) {
    // } else {
    // console.log('checking22', new Date());
    // }
  };

  const handleLocationError = (error) => {
    console.error('Error getting coordinates:', error);
  };

  const getCurrentPosition = () => {
    console.log('checking');

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleLocationUpdate, handleLocationError, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      });
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  };

  const shouldGetLocation = localStorage.getItem('routeLocation');

  const stopBreakAlert = () => {
    setViolationAcknowledged(true);
    setAlertShown(false);

    setTimeout(() => {
      setViolationAcknowledged(false);
    }, 5 * 60 * 1000);
  };

  useEffect(() => {
    if (shouldGetLocation === 'true') {
      console.log('Starting location tracking');
      getCurrentPosition();
      const intervalId = setInterval(getCurrentPosition, 6000);

      return () => clearInterval(intervalId);
    }
  }, [previousCoords, shouldGetLocation]);

  useEffect(() => {
    if (violation && !violationAcknowledged) {
      if (!alertShown) {
        play();
        setAlertShown(true);
      }
    } else {
      stop();
      if (alertShown) {
        setAlertShown(false);
      }
      if (!violation && violationAcknowledged) {
        setViolationAcknowledged(false);
      }
    }
  }, [violation, violationAcknowledged, alertShown, play, stop]);


  useEffect(() => {
    const resumeAudio = () => {
      if (Howler.ctx && Howler.ctx.state === "suspended") {
        Howler.ctx.resume().catch(() => { });
      }
    };

    window.addEventListener("click", resumeAudio, { once: true });
    window.addEventListener("touchstart", resumeAudio, { once: true });

    return () => {
      window.removeEventListener("click", resumeAudio);
      window.removeEventListener("touchstart", resumeAudio);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
      setManualTachos(localStorage.getItem("manualTachos"));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <SideBar style={{ height: "100vh" }}>
      {/* <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo-container">
          {!collapsed ? (
            <img style={{ height: "32px" }} src={AppLogo} alt="appLogo" />
          ) : (
            <img style={{ height: "32px" }} src={AppIcon} alt="appIcon" />
          )}

        </div>
        
      </Sider> */}
      <SideBar style={{ padding: "0" }}>
        <Header style={{ padding: "0", background: "white", borderBottom: '1px solid lightBlue', height: '80px' }}>
          {/* {
            !name && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 20px', marginTop: '10px'}}>
                
              <img style={{ height: "42px" }} src={AppLogo} alt="appIcon" />
            
              <h1 style={{ margin: '0px' }}>Magna Driver App</h1>
              
            
              </div>
            )
          } */}
          {
            !name && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 20px', marginTop: '10px' }}>

                <img style={{ height: "42px", marginTop: currWidth <= 450 && '10px' }} src={AppLogo} alt="appIcon" />

                {currWidth >= 450 && <h1 style={{ margin: '0px', textAlign: 'center' }}>Magna Driver App</h1>}

                {currWidth >= 700 && <div style={{ width: "175px" }}></div>}

              </div>
            )
          }

          <div
            style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}
            className=" header-container"
          >
            <div style={{ display: 'flex', alignItems: "center" }}>
              {
                name && (
                  currWidth >= 800 ? <img style={{ height: "42px", marginRight: '5px' }} src={AppLogo} alt="appIcon" />
                    : <img style={{ height: "42px", marginRight: '5px' }} src={AppIcon} alt="appIcon" />
                )
              }
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {
                  routeName && (
                    <Button
                      iconPosition='end'
                      style={{
                        marginTop: '5px',
                        marginBottom: ''
                      }}
                      danger
                      // icon={<ExclamationOutlined />}              
                      size="medium"
                      onClick={reportAccident}
                    >
                      Report Accident
                    </Button>
                  )
                }
                {
                  routeName && showReport && (
                    <Button
                      style={{
                        marginTop: '5px',
                        marginBottom: ''
                      }}

                      size="medium"
                      onClick={() => navigate('/report', { state: { readReport: true } })}
                    >
                      Defect Sheet
                    </Button>
                  )
                }
              </div>
            </div>




            {currWidth >= 600 && (
              <>
                {
                  routeName && (
                    <div className={classes.dataSheet}>
                      <Descriptions bordered size={"small"}
                        style={{ marginTop: '5px' }}
                      >
                        <Descriptions.Item
                          label={'Route'}
                          labelStyle={{ width: "60px" }}
                          contentStyle={{ minWidth: '170px', maxWidth: '170px' }}

                        >
                          {
                            routeName ? (
                              <>
                                <Tag style={{ fontSize: '16px' }} color="blue">{routeName}</Tag>

                              </>
                            ) : ''
                          }
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={'Vehicle'}
                          labelStyle={{ width: "60px" }}
                          contentStyle={{ minWidth: '160px', maxWidth: '160px' }}

                        >
                          {
                            routeName ? (
                              <>
                                {/* <Tag style={{ fontSize: '16px'}} color="blue">{deliveryDate ?  moment(deliveryDate).format('DD-MM-YYYY') : '' }</Tag> */}
                                <Tag style={{ fontSize: '16px' }} color="blue">{currentRoute?.vehicle}</Tag>


                              </>
                            ) : ''
                          }
                        </Descriptions.Item>
                      </Descriptions>
                      <Descriptions style={{ marginTop: '2px' }} bordered size={"small"} >
                        <Descriptions.Item
                          label={'Driver'}
                          labelStyle={{ width: "60px" }}
                          contentStyle={{ minWidth: '170px', maxWidth: '170px' }}
                        >
                          {
                            routeName ? (
                              <>

                                {/* <Tag style={{ fontSize: '16px'}}a color="blue">{currentRoute?.vehicle}</Tag> */}
                                <Tag style={{ fontSize: '16px' }} color="blue">{currentRoute?.driver_name?.split(' ')[0]}</Tag>


                              </>
                            ) : ''
                          }
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={'Date'}
                          labelStyle={{ width: "60px" }}
                          contentStyle={{ minWidth: '160px', maxWidth: '160px' }}
                        >
                          {
                            routeName ? (
                              <>
                                <Tag style={{ fontSize: '16px' }} color="blue">{deliveryDate ? moment(deliveryDate).format('DD-MM-YYYY') : ''}</Tag>

                              </>
                            ) : ''
                          }
                        </Descriptions.Item>

                      </Descriptions>

                      {/* <span className="user-name">
              {routeName ? `  ${routeName}:  ${currentRoute?.driver_name} (${currentRoute?.vehicle} - ${deliveryDate ? moment(deliveryDate).format('DD-MM-YYYY'): ''})` : ""}
              </span> */}

                    </div>
                  )
                }
              </>

            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <>

                <>
                  {currWidth >= 960 && (
                    <>
                      {name && (
                        <span className="light-span">
                          Hello,{" "}
                          <strong className="user-name">{name ? name : ""}</strong>
                        </span>
                      )
                      }
                    </>
                  )}
                  {
                    name ? (
                      <Dropdown overlay={menu} arrow>
                        <Avatar className="avatar-extra" size={50}>
                          {name ? name.charAt(0).toUpperCase() : 'A'}
                        </Avatar>
                      </Dropdown>
                    ) : null
                  }

                </>

              </>

            </div>
          </div>
        </Header>
        <div className="content-wrapper">
          <Content style={{ background: "white" }} className="context-box">
            {/* {contentLoading && <ContentSpinner />} */}
            {violation && (
              <BreakAlertModal
                open={alertShown}
                onAcknowledge={stopBreakAlert}
                formattedTime={formattedTime}
                selectedRouteData={currentRoute}
              />
            )}
            <Outlet />
          </Content>
        </div>
      </SideBar>
      <Loading />
    </SideBar>
  );
};

export default AppLayout;
